import { combineReducers } from '@reduxjs/toolkit';
import frontend from './frontendSlice';

const sharedReducers = combineReducers({
	frontend,
});

export default sharedReducers;
